import { useEffect } from "react"
import types from "prop-types"
import { store } from "store"
import { setCustomNames } from "reduxSlices/customNamesSlice"
import { CustomNameShape } from "utils/propTypeShapes"

const SetupCustomNamesInRedux = ({ customNames }) => {
  useEffect(() => {
    store.dispatch(setCustomNames(customNames))
  }, [customNames])

  return null
}

SetupCustomNamesInRedux.propTypes = {
  customNames: types.arrayOf(CustomNameShape).isRequired,
}

export default SetupCustomNamesInRedux
